import Quill from 'quill';

const EMPTY_HTML_VALUES = ['<p></p>', '<div></div>', '<p><br></p>', '<div><br></div>'];

/**
 * Returns the editor content as HTML, for use as the quill-editor [valueGetter].
 * Quill 2.0.3's getSemanticHTML() emits every space as &nbsp;, which keeps saved text (e.g. notification
 * emails) from wrapping, so spaces are restored to match the HTML Quill 1 produced. (2.0.2, the pinned
 * version, emits plain spaces; this keeps output stable if quill is upgraded.)
 */
export function getQuillHtml(editor: Quill): string | null {
  const html = editor.getSemanticHTML().replace(/&nbsp;/g, ' ');
  return EMPTY_HTML_VALUES.includes(html) ? null : html;
}
